import { createReducer, on } from '@ngrx/store';
import { InitialState, ReviewInsightsFeatureState } from './insights-state';
import { LocationComparisonActions, LocationComparisonCountActions, MapLocationsActions, PostsPerWeekdayActions, PostTimesActions, RatingActions, RespondedCommentedActions, ResponseTimesActions, ResponseTimesOverviewActions, ReviewNumbersActions, syncInsightsFilters, syncLocationComparisonTableSettings, TopLocationsActions, updateFiltersForSuccessfulInsightsCall } from './insights-actions';

export const insightsReducer = createReducer(InitialState,
    on(LocationComparisonActions.getLocationComparisonListSuccess,
        (state, { locationComparisonList }): ReviewInsightsFeatureState => ({
          ...state, locationComparisonList,
        })),
    on(LocationComparisonActions.getLocationComparisonListFail,
        (state): ReviewInsightsFeatureState => ({
          ...state, locationComparisonList: null,
        })),

    on(MapLocationsActions.getMapLocationsSuccess,
        (state, { mapLocations }): ReviewInsightsFeatureState => ({
          ...state, mapLocations,
        })),
    on(MapLocationsActions.getMapLocationsFail,
        (state): ReviewInsightsFeatureState => ({
          ...state, mapLocations: null,
        })),
    on(MapLocationsActions.clearMapLocations,
        (state): ReviewInsightsFeatureState => ({
          ...state, mapLocations: null,
        })),

    on(LocationComparisonCountActions.getLocationComparisonCountSuccess,
        (state, { locationComparisonCount }): ReviewInsightsFeatureState => ({
          ...state, locationComparisonCount,
        })),
    on(LocationComparisonCountActions.getLocationComparisonCountFail,
        (state): ReviewInsightsFeatureState => ({
          ...state, locationComparisonCount: null,
        })),

    on(PostsPerWeekdayActions.getPostsPerWeekdaySuccess,
        (state, { postsPerWeekday }): ReviewInsightsFeatureState => ({
          ...state, postsPerWeekday,
        })),
    on(PostsPerWeekdayActions.getPostsPerWeekdayFail,
        (state): ReviewInsightsFeatureState => ({
          ...state, postsPerWeekday: null,
        })),

    on(PostTimesActions.getPostTimesSuccess,
        (state, { postTimes }): ReviewInsightsFeatureState => ({
          ...state, postTimes,
        })),
    on(PostTimesActions.getPostTimesFail,
        (state): ReviewInsightsFeatureState => ({
          ...state, postTimes: null,
        })),

    on(RatingActions.getRatingSuccess,
        (state, { rating }): ReviewInsightsFeatureState => ({
          ...state, rating,
        })),
    on(RatingActions.getRatingFail,
        (state): ReviewInsightsFeatureState => ({
          ...state, rating: null,
        })),

    on(RespondedCommentedActions.getRespondedCommentedSuccess,
        (state, { respondedCommented }): ReviewInsightsFeatureState => ({
          ...state, respondedCommented,
        })),
    on(RespondedCommentedActions.getRespondedCommentedFail,
        (state): ReviewInsightsFeatureState => ({
          ...state, respondedCommented: null,
        })),

    on(ResponseTimesActions.getResponseTimesSuccess,
        (state, { responseTimes }): ReviewInsightsFeatureState => ({
          ...state, responseTimes,
        })),
    on(ResponseTimesActions.getResponseTimesFail,
        (state): ReviewInsightsFeatureState => ({
          ...state, responseTimes: null,
        })),

    on(ResponseTimesOverviewActions.getResponseTimesOverviewSuccess,
        (state, { responseTimesOverview }): ReviewInsightsFeatureState => ({
          ...state, responseTimesOverview,
        })),
    on(ResponseTimesOverviewActions.getResponseTimesOverviewFail,
        (state): ReviewInsightsFeatureState => ({
          ...state, responseTimesOverview: null,
        })),

    on(ReviewNumbersActions.getReviewNumbersSuccess,
        (state, { reviewNumbers }): ReviewInsightsFeatureState => ({
          ...state, reviewNumbers,
        })),
    on(ReviewNumbersActions.getReviewNumbersFail,
        (state): ReviewInsightsFeatureState => ({
          ...state, reviewNumbers: null,
        })),

    on(TopLocationsActions.getTopLocationsSuccess,
        (state, { topLocations }): ReviewInsightsFeatureState => ({
          ...state, topLocations,
        })),
    on(TopLocationsActions.getTopLocationsFail,
        (state): ReviewInsightsFeatureState => ({
          ...state, topLocations: null,
        })),

    on(syncInsightsFilters,
        (state, { filters }): ReviewInsightsFeatureState => ({
          ...state,
          filters,
          locationComparisonTableSettings: {
            ...state.locationComparisonTableSettings,
            pageIndex: 0, // always set pageIndex to 0 in this case to prevent possible BE errors
          },
        })),
    on(updateFiltersForSuccessfulInsightsCall,
        (state, { filters, insightsMethod }): ReviewInsightsFeatureState => ({
          ...state,
          filtersForSuccessfulInsightsCalls: {
            ...state.filtersForSuccessfulInsightsCalls,
            [insightsMethod]: filters,
          },
        })),
    on(syncLocationComparisonTableSettings,
        (state, { locationComparisonTableSettings }): ReviewInsightsFeatureState => ({
          ...state, locationComparisonTableSettings,
        })),
);
